import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const createCategoryAction = createAsyncThunk(
    'create-category',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/support-server/api/create-category`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createCategorySlice = createSlice({
    name: 'create-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createCategoryReducer = createCategorySlice.reducer